<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1">CONTENTS</h1>
<p class="toc"><a href="#/OEBPS/tp">Title Page</a></p>
<p class="toc"><a href="#/OEBPS/cpn">Copyright Notice</a></p>
<p class="toc"><a href="#/OEBPS/fm">“But Didn’t They <em>Smell</em>?”</a></p>
<p class="toc"><a href="#/OEBPS/c01"><strong>ONE</strong><br/>The Social Bath: Greeks and Romans</a></p>
<p class="toc"><span href="#/OEBPS/c02" title="Link target outside of Sample"><strong>TWO</strong><br/>Bathed in Christ: 200–1000</span></p>
<p class="toc"><span href="#/OEBPS/c03" title="Link target outside of Sample"><strong>THREE</strong><br/>A Steamy Interlude: 1000–1550</span></p>
<p class="toc"><span href="#/OEBPS/c04" title="Link target outside of Sample"><strong>FOUR</strong><br/>A Passion for Clean Linen: 1550–1750</span></p>
<p class="toc"><span href="#/OEBPS/c05" title="Link target outside of Sample"><strong>FIVE</strong><br/>The Return of Water: 1750–1815</span></p>
<p class="toc"><span href="#/OEBPS/c06" title="Link target outside of Sample"><strong>SIX</strong><br/>Baths and How to Take Them: Europe, 1815–1900</span></p>
<p class="toc"><span href="#/OEBPS/c07" title="Link target outside of Sample"><strong>SEVEN</strong><br/>Wet All Over at Once: America, 1815–1900</span></p>
<p class="toc"><span href="#/OEBPS/c08" title="Link target outside of Sample"><strong>EIGHT</strong><br/>Soap Opera: 1900–1950</span></p>
<p class="toc"><span href="#/OEBPS/c09" title="Link target outside of Sample"><strong>NINE</strong><br/>The Household Shrine: 1950 to the Present</span></p>
<p class="toc"><span href="#/OEBPS/ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc"><span href="#/OEBPS/note" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/OEBPS/bib" title="Link target outside of Sample"><em>Selected Bibliography</em></span></p>
<p class="toc"><span href="#/OEBPS/ind" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span href="#/OEBPS/per" title="Link target outside of Sample">Text Permissions</span></p>
<p class="toc"><span href="#/OEBPS/cre" title="Link target outside of Sample">Illustration Credits</span></p>
<p class="toc"><span href="#/OEBPS/als" title="Link target outside of Sample">Also by Katherine Ashenburg</span></p>
<p class="toc"><span href="#/OEBPS/copy" title="Link target outside of Sample">Copyright</span><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/006_Ashe_art_r1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2ba8c861